import {configureStore} from '@reduxjs/toolkit';
import authReducer from './auth';
import cartReducer from './cartdata'
import spinReducer from './spinner'

export const store = configureStore({
    reducer:{
         auth:authReducer,
         cart:cartReducer,
         spin:spinReducer
    }
})
export const { dispatch, getState } = store; 